import dfCapitalTheme from "./dfCapitalTheme";
import theme from "./theme";
import uverifiTheme from "./uverifiTheme";

export default {
    checkventory: theme,
    uverifi: uverifiTheme,
    "DF Capital": dfCapitalTheme
};
